/** Liste des type de recherche de noeud possible pour les widgets */
enum TypeSearchEnum {
	/** Aucun état (1er chargement d'un widget) */
	None = 0, 
	/** Selection de noeud par nom */
	NameSearch = 1, 
	/** Selection de noeud par type */
	TypeSearch = 2,
	/** Selection de noeud par périmétre utilisateur */
	PerimeterSearch = 3 
};

export default TypeSearchEnum;